// extracted by mini-css-extract-plugin
export default {"imageWrapper":"CJ-z","twoColumnImage":"DJ-z"};